module.exports = __webpack_public_path__ + "static/img/brochure_lumiere.1a3f346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/brochure_lumiere.jpg
// module id = 24
// module chunks = 0